import { useTranslation } from "react-i18next";
import { ISError } from "./ISError";

export const PageNotFound = () =>{
    const {t} = useTranslation("others")

    return <ISError title={t("pageNotFound.title")!} error={t("pageNotFound.text")!}/>
}